import React from 'react';
import { Plus } from 'lucide-react';
import { MenuItem } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
import { useLanguage } from '../../lib/i18n';
interface MenuItemCardProps {
  item: MenuItem;
  onClick: (item: MenuItem) => void;
  primaryColor?: string;
  displayName?: string;
  displayDescription?: string | null;
  theme?: 'default' | 'capricho';
}
export function MenuItemCard({
  item,
  onClick,
  primaryColor,
  displayName,
  displayDescription,
  theme = 'default'
}: MenuItemCardProps) {
  const {
    t
  } = useLanguage();
  const itemName = displayName || item.name;
  const itemDesc = displayDescription !== undefined ? displayDescription : item.description;
  const isCapricho = theme === 'capricho';
  return <button onClick={() => onClick(item)} className={isCapricho ? 'w-full bg-white rounded-2xl overflow-hidden border border-[#E8DDD0] hover:border-[#8B5E3C]/30 transition-all hover:shadow-xl hover:shadow-[#8B5E3C]/5 group text-left' : 'w-full bg-[#141414] rounded-2xl overflow-hidden border border-white/5 hover:border-[#C9A34E]/30 transition-all hover:shadow-xl hover:shadow-[#C9A34E]/5 group text-left'} data-id="element-1165">
      {item.image_url && <div className={`relative w-full h-40 sm:h-48 ${isCapricho ? 'bg-[#F5EDE3]' : 'bg-[#0B0B0B]'} overflow-hidden`} data-id="element-1166">
          <img src={item.image_url} alt={itemName} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1167" />
          <div className={`absolute inset-0 bg-gradient-to-t ${isCapricho ? 'from-white' : 'from-[#0B0B0B]'} via-transparent to-transparent`} data-id="element-1168" />
        </div>}

      <div className="p-4 sm:p-5" data-id="element-1169">
        <div className="flex justify-between items-start gap-3 mb-2" data-id="element-1170">
          <h3 className={isCapricho ? 'text-lg sm:text-xl font-black text-[#3D2B1F] leading-tight group-hover:text-[#8B5E3C] transition-colors' : 'text-lg sm:text-xl font-black text-white leading-tight group-hover:text-[#C9A34E] transition-colors'} style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-1171">
            {itemName}
          </h3>
          <span className={isCapricho ? 'text-lg sm:text-xl font-bold text-[#8B5E3C] whitespace-nowrap' : 'text-lg sm:text-xl font-bold text-[#C9A34E] whitespace-nowrap'} data-id="element-1172">
            {formatCurrency(Number(item.price) || 0)}
          </span>
        </div>

        {itemDesc && <p className={`text-sm ${isCapricho ? 'text-[#8B7355]/70' : 'text-white/60'} mb-4 line-clamp-2 leading-relaxed`} data-id="element-1173">
            {itemDesc}
          </p>}

        <div className="flex items-center justify-between" data-id="element-1174">
          <div className="flex-1" data-id="element-1175" />
          <div className={isCapricho ? 'flex items-center gap-2 text-sm font-bold text-[#8B5E3C] group-hover:text-[#3D2B1F] transition-colors' : 'flex items-center gap-2 text-sm font-bold text-[#C9A34E] group-hover:text-white transition-colors'} data-id="element-1176">
            <Plus className="w-5 h-5" data-id="element-1177" />
            <span data-id="element-1178">{t('add_to_cart')}</span>
          </div>
        </div>
      </div>
    </button>;
}